import {getAvatars, getExtraGuestsCount, isRsvp} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import _ from 'lodash'
import React from 'react'
import {AvatarGroup, AvatarGroupSize, HoverStyles} from 'wix-ui-tpa/cssVars'
import {MembersProps} from './interfaces'
import {classes} from './members.st.css'

const MAX_AVATARS = 3

export const Members = ({
  event,
  onImage,
  singleLayout,
  calendarLayout,
  listLayout,
  onClick,
  t,
  showMembers,
}: MembersProps) => {
  const {members} = event
  const totalGuests = _.isObject(event.totalGuests) && _.isEmpty(event.totalGuests) ? 0 : event.totalGuests
  const items = getAvatars(members, totalGuests, isRsvp(event), MAX_AVATARS, showMembers)
  const extraGuests = totalGuests !== undefined && getExtraGuestsCount(totalGuests, MAX_AVATARS)

  const handleClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation()
    onClick(event.id)
  }

  let avatarsClass = classes.avatarsDefault

  if (onImage) {
    avatarsClass = classes.avatarsOnImage
  } else if (singleLayout) {
    avatarsClass = classes.avatarsSingleLayout
  } else if (calendarLayout) {
    avatarsClass = classes.avatarsCalendarLayout
  } else if (listLayout) {
    avatarsClass = classes.avatarsListLayout
  }

  return (
    <div className={classes.root}>
      <AvatarGroup
        {...{className: classNames(avatarsClass)}}
        maxAmount={MAX_AVATARS}
        items={items}
        size={AvatarGroupSize.small}
        data-hook={DH.members}
      >
        <AvatarGroup.TextButton
          onClick={handleClick}
          className={classes.avatar}
          aria-haspopup="dialog"
          aria-label={t('members.guestDetails')}
          hoverStyle={HoverStyles.underline}
        >
          {extraGuests ? t('members.moreLink', {amount: extraGuests}) : t('members.seeAll')}
        </AvatarGroup.TextButton>
      </AvatarGroup>
    </div>
  )
}
